import { getAreaList, getFilterData } from './api';

class FilterData {
  constructor() {}
  private filterData = [];
  private areaData = [];

  async getFilterConfigs(force = false) {
    if (force || !this.filterData?.length) {
      return await this.queryFilterData();
    }

    return this.filterData;
  }

  private async queryFilterData() {
    const res = await getFilterData();
    this.filterData = res;
    return this.filterData;
  }

  async getAreaData() {
    if (!this.areaData?.length) {
      return await this.queryAreaData();
    }

    return this.areaData;
  }

  private async queryAreaData() {
    const res = await getAreaList();
    this.areaData = res;
    return this.areaData;
  }
}

export default new FilterData();
